export const convertToNumber = (value): number => {
  const num = Number(value);
  return !isNaN(num) ? num : undefined;
};
